import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { CtaBlock } from "@/components/CtaBlock";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { PRODUCT_PAGES } from "@/data/site";

const productJsonLd = {
  "@context": "https://schema.org", "@type": "Product", name: "SENIORCAR",
  description: "Dispositivo medico monoposto per la mobilità di persone con patologie permanenti e difficoltà motorie.",
  brand: { "@type": "Brand", name: "SENIORCAR" },
  image: "https://images.unsplash.com/photo-1781265285262-88b327f3c730?w=800",
};

export default function Seniorcar() {
  const entries = Object.entries(PRODUCT_PAGES);
  return (
    <>
      <Seo title="SENIORCAR — Dispositivo medico per la mobilità"
        description="Scopri SENIORCAR: dispositivo medico monoposto per persone con difficoltà motorie. Senza patente né targa, autonomia fino a 120 km, velocità 20 km/h."
        keywords="seniorcar, dispositivo medico mobilità, mobilità difficoltà motorie" jsonLd={productJsonLd} />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "SENIORCAR" }]} /></div>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-6 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>SENIORCAR</h1>
          <p className="mt-4 text-lg sm:text-xl text-slate-600 leading-relaxed">
            Un dispositivo medico monoposto con abitacolo chiuso, semplice da usare. Progettato per le persone con patologie permanenti e difficoltà motorie,
            per offrire indipendenza, comfort e protezione dal meteo. Senza patente né targa.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Link to="/prenota-prova"><Button className="h-13 px-6 h-12 font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-amber)" }} data-testid="seniorcar-prenota">Prenota una prova</Button></Link>
            <Link to="/contatti"><Button variant="outline" className="h-12 px-6 font-bold rounded-full border-2 border-emerald-800 text-emerald-900">Richiedi informazioni</Button></Link>
          </div>
        </div>
        <img src="https://customer-assets-rejwkqb3.emergentagent.net/job_seniorcar-discover/artifacts/8ee3cd1ddbda1615_B258CC0C-3A2A-4B23-B4A6-78AC99C37FAC.png"
          alt="Signora senior accanto a SENIORCAR in piazza davanti a un bar: libertà e autonomia negli spostamenti quotidiani" loading="eager" className="rounded-3xl w-full h-[360px] sm:h-[440px] object-cover object-center shadow-lg" />
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-6" style={{ fontFamily: "Outfit" }}>Approfondisci SENIORCAR</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {entries.map(([slug, p]) => (
            <Link key={slug} to={`/seniorcar/${slug}`} className="rounded-2xl bg-white border border-slate-200 p-5 hover:shadow-md hover:-translate-y-1 transition-all group" data-testid={`seniorcar-link-${slug}`}>
              <h3 className="text-lg font-bold text-slate-900 group-hover:text-emerald-800" style={{ fontFamily: "Outfit" }}>{p.title.replace("SENIORCAR", "").trim() || p.title}</h3>
              <p className="mt-1.5 text-slate-600 text-sm line-clamp-2">{p.answer}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-emerald-800 font-semibold text-sm">Scopri <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-16"><CtaBlock variant="test" /></section>
    </>
  );
}
